import { render, staticRenderFns } from "./ManuaisRoteirosAtosForm.vue?vue&type=template&id=19d53f27"
import script from "./ManuaisRoteirosAtosForm.vue?vue&type=script&lang=js"
export * from "./ManuaisRoteirosAtosForm.vue?vue&type=script&lang=js"
import style0 from "./ManuaisRoteirosAtosForm.vue?vue&type=style&index=0&id=19d53f27&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports